import React, { useRef } from "react";
import Select from "react-select";
import { COLORS, sharedConstants } from "../../../constants";

function SelectField({
  value,
  setValue,
  options = [],
  label,
  className,
  id,
  placeholder,
  error,
  disabled,
  labelKey = "label",
  valueKey = "value",
}) {
  const selectRef = useRef(null);

  const handleChange = (option) => {
    setValue(option);
  };

  const customStyles = {
    singleValue: (provided, state) => ({
      ...provided,
      color: state.isDisabled ? "gray" : "black",
      fontSize: "0.75rem",
    }),
    control: (base, state) => ({
      ...base,
      cursor: "pointer",
      boxShadow: "none",
      borderColor: "rgba(231, 231, 231, 1)",
      "&:hover": {
        borderColor: "rgba(231, 231, 231, 1)",
      },
      backgroundColor: "white",
      borderBottomLeftRadius: state.menuIsOpen
        ? 0
        : base.borderBottomLeftRadius,
      borderBottomRightRadius: state.menuIsOpen
        ? 0
        : base.borderBottomRightRadius,
      borderBottom: state.menuIsOpen ? "none" : base.borderBottom,
    }),

    option: (base, state) => ({
      ...base,
      cursor: "pointer",
      padding: "6px 8px",
      lineHeight: "1.2",
      fontSize: "0.75rem",
      backgroundColor: state.isSelected ? "rgba(223, 240, 242, 1)" : "white",
      boxSizing: "border-box",
      borderRadius: "4px",
      margin: "2px 0",
      color: "black",
      ":hover": {
        backgroundColor: "rgba(223, 240, 242, 1)",
      },
    }),

    menu: (base) => ({
      ...base,
      marginTop: 0,
      backgroundColor: "white",
      border: "1px solid rgba(231, 231, 231, 1)",
      borderTop: "none",
      borderBottomLeftRadius: "4px",
      borderBottomRightRadius: "4px",
      boxShadow: "none",
    }),

    menuList: (base) => ({
      ...base,
      backgroundColor: "white",
      padding: "2px",
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: ".75rem",
    }),
    dropdownIndicator: (base, state) => ({
      ...base,
      color: COLORS.Teal,
      transition: "transform 0.2s ease",
      transform: state.selectProps.menuIsOpen
        ? "rotate(180deg)"
        : "rotate(0deg)",
    }),
  };

  // Find the matching option object from the value
  const selectedOption =
    typeof value === sharedConstants.OBJECT && value !== null
      ? value
      : options.find((opt) => opt[valueKey] === value) || null;

  return (
    <>
      {label && (
        <label htmlFor={id} className="select-label">
          {label}
        </label>
      )}
      <Select
        ref={selectRef}
        className={className}
        id={id}
        value={selectedOption}
        onChange={handleChange}
        options={options}
        components={{
          IndicatorSeparator: () => null,
        }}
        getOptionLabel={(option) => option[labelKey] ?? ""}
        getOptionValue={(option) => option[valueKey]}
        placeholder={placeholder}
        styles={customStyles}
        isDisabled={disabled}
        classNames={{
          control: () => "custom-select-control",
          menuList: (state) => "px-1 menu-list",
          singleValue: () => "custom-single-select-value",
        }}
      />
      {error && <p className="invalid-field-error m-0">{error}</p>}
    </>
  );
}

export default SelectField;
